import React, { FC, useCallback, useRef, useState } from 'react'
import { Grid } from '@mui/material'
import { CollapsibleSection, HasSidebarLayout, ListHeader, SensorBillingEstimates, SensorBillingSensorsTables, SensorBillingStatsAnalytics } from 'src/components'

const SensorBillingStatsListPage: FC = () => {
  document.title = 'CLīMIT Admin Panel - CLIMIT Sensors Billing Stats'
  const [sensorsExpanded, setSensorsExpanded] = useState(false)
  const sensorsSectionRef = useRef<HTMLDivElement>(null)

  const handleStatSelect = useCallback(() => {
    setSensorsExpanded(true)
    sensorsSectionRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [])

  return (
    <HasSidebarLayout>
      <ListHeader title="CLIMIT Sensors Billing Stats" />
      <Grid container spacing={2} direction="column" wrap="nowrap">
        <Grid item xs={12}>
          <CollapsibleSection title="Estimates" defaultExpanded>
            <SensorBillingEstimates />
          </CollapsibleSection>
        </Grid>
        <Grid item xs={12}>
          <CollapsibleSection title="Analytics">
            <SensorBillingStatsAnalytics onStatSelect={handleStatSelect} />
          </CollapsibleSection>
        </Grid>
        <Grid item xs={12} ref={sensorsSectionRef}>
          <CollapsibleSection title="Sensors" expanded={sensorsExpanded} onExpandedChange={setSensorsExpanded}>
            <SensorBillingSensorsTables />
          </CollapsibleSection>
        </Grid>
      </Grid>
    </HasSidebarLayout>
  )
}

export default SensorBillingStatsListPage
